'use client'
import React, { useState } from 'react'
import Menu from '../icons/Menu'
import ToggleMenu from './ToggleMenu'
import { ResponsiveRolzoLogo } from '../icons'
import './mobileNavbar.scss'
import { useMotionValueEvent, useScroll } from 'framer-motion'
import { Link } from 'navigation'
import { useTranslations } from 'next-intl'
const MobileNavbar = () => {
  const [isOpenMenu, setIsOpenMenu] = useState(false)
  const t = useTranslations('Navbar')
  const [toggleLinkDropdown, setToggleLinkDropdown] = useState({
    [t(`services.name`)]: false,
    [t(`fleet.name`)]: false,
  })
  const handleToggleDropdown = (name) => {
    setToggleLinkDropdown((prevState) => ({
      ...prevState,
      [name]: !prevState[name],
    }))
  }
  const handleOpenMenu = () => {
    setIsOpenMenu(true)
  }
  const handleCloseMenu = () => {
    setIsOpenMenu(false)
    setToggleLinkDropdown((prevState) => {
      const resetDropdowns = Object.keys(prevState).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});
      return resetDropdowns;
    });
  }
  const { scrollY } = useScroll();
  
  const [isFixed, setIsFixed] = useState(false);

  useMotionValueEvent(scrollY, "change", (latest) => {
    setIsFixed(latest > 100);
  });
  return (
    <nav >
      <div className={`mobilenav ${isFixed ? 'fixed' : ""}`}>
        <div className='inner-container'>
          <Link href='/'>
      <ResponsiveRolzoLogo />
          </Link>
      <div onClick={handleOpenMenu}>
        <Menu/>
      </div>
        </div>
        </div>
      <ToggleMenu isOpenMenu={isOpenMenu} handleToggleDropdown={handleToggleDropdown} handleCloseMenu={handleCloseMenu} setToggleLinkDropdown={setToggleLinkDropdown} toggleLinkDropdown={toggleLinkDropdown}  />
    </nav>
  )
}
export default MobileNavbar
